module.exports = __webpack_public_path__ + "src/assets/img/stamp.4cd343a5.png";